module.exports = __webpack_public_path__ + "img/autocar.5445cefb.png";